export default __webpack_public_path__ + "static/media/3-LazyNikau.e4851fb7.jpeg";